/**
 * useVehicles — 차량 목록 실시간 구독.
 */
import { useEffect, useState } from "react";
import { vehiclesRepo } from "@/services/vehicles.repository";
import type { Vehicle } from "@/domain/vehicle";

export interface UseVehiclesState {
  rows: Vehicle[];
  loading: boolean;
  error: string | null;
}

export function useVehicles(): UseVehiclesState {
  const [rows, setRows] = useState<Vehicle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsub = vehiclesRepo.subscribeAll(
      (data) => {
        setRows(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setRows([]);
        setLoading(false);
        setError(err.message);
      },
    );
    return unsub;
  }, []);

  return { rows, loading, error };
}
